import type { SxProps } from "@mui/material"

const container: SxProps = {
  background: "#F1F1F1"
}

const content: SxProps = {
  justifyContent: "space-between",
  alignItems: "center",
  pr: 2,
  minWidth: "15rem"
}

export default { container, content }
